import { CTAButton } from 'src/common/components/Button';

export default CTAButton;
